/**
 * Centralized registry of all weretradeIT internal and external applications
 * Used by AppLauncher for quick access navigation
 */
/**
 * Base URL for logo assets
 * All logos are hosted on intranet.weretrade.com for consistent access across apps
 */
const LOGO_BASE_URL = 'https://intranet.weretrade.com/logos';
/**
 * All registered weretradeIT applications
 * Add new apps here to make them available in the launcher
 */
export const APPS_REGISTRY = [
    // Core Internal Apps
    {
        id: 'intranet',
        name: 'Intranet Spider',
        description: 'Central dashboard & app portal',
        icon: `${LOGO_BASE_URL}/intranetSpider.png`,
        url: 'https://intranet.weretrade.com',
        color: '#3b82f6', // blue
        category: 'core',
        requiresAuth: true,
    },
    {
        id: 'services',
        name: 'Service Ant',
        description: 'Services management portal',
        icon: `${LOGO_BASE_URL}/serviceAnt.png`,
        url: 'https://services.weretrade.com',
        color: '#8b5cf6', // purple
        category: 'core',
        requiresAuth: true,
    },
    {
        id: 'shop',
        name: 'Shop Beaver',
        description: 'E-commerce admin & inventory',
        icon: `${LOGO_BASE_URL}/shopBeaver.png`,
        url: 'https://shop.weretrade.com',
        color: '#f59e0b', // amber
        category: 'core',
        requiresAuth: true,
    },
    {
        id: 'inventar',
        name: 'Inventar Owl',
        description: 'Inventory management system',
        icon: `${LOGO_BASE_URL}/inventarOwl.png`,
        url: 'https://inventar.weretrade.com',
        color: '#10b981', // green
        category: 'tools',
        requiresAuth: true,
    },
    {
        id: 'accounting',
        name: 'Account Fox',
        description: 'Financial tracking & reporting',
        icon: `${LOGO_BASE_URL}/accountFox.png`,
        url: 'https://fox.weretrade.com',
        color: '#ef4444', // red
        category: 'tools',
        requiresAuth: true,
    },
    {
        id: 'assetbee',
        name: 'AssetBee',
        description: 'Animal asset showcase manager & analytics',
        icon: `${LOGO_BASE_URL}/assetBee.png`,
        url: 'https://assets.weretrade.com',
        color: '#ff5fd7', // pink
        category: 'tools',
        requiresAuth: true,
    },
    // Analytics & Insights
    {
        id: 'neural-whale',
        name: 'Neural Whale',
        description: 'Knowledge graph & workflows',
        icon: `${LOGO_BASE_URL}/neuralWhale.png`,
        url: 'https://neural.weretrade.com',
        color: '#06b6d4', // cyan
        category: 'analytics',
        requiresAuth: true,
    },
    {
        id: 'metric-mole',
        name: 'Metric Mole',
        description: 'Performance metrics & analytics',
        icon: `${LOGO_BASE_URL}/metricMole.png`,
        url: 'https://mole.weretrade.com',
        color: '#ec4899', // pink
        category: 'analytics',
        requiresAuth: true,
    },
    {
        id: 'market-shark',
        name: 'Market Shark',
        description: 'Market analysis & trends',
        icon: `${LOGO_BASE_URL}/marketShark.png`,
        url: 'https://shark.weretrade.com',
        color: '#14b8a6', // teal
        category: 'analytics',
        requiresAuth: true,
    },
    // Design & Development Tools
    {
        id: 'design-butterfly',
        name: 'Design Butterfly',
        description: 'Design system & components',
        icon: `${LOGO_BASE_URL}/designButterfly.png`,
        url: 'https://designbutterfly-pages.pages.dev',
        color: '#a855f7', // violet
        category: 'tools',
        requiresAuth: true,
    },
    {
        id: 'pipe-squid',
        name: 'Pipe Squid',
        description: 'Pipeline orchestration & automation',
        icon: `${LOGO_BASE_URL}/pipeSquid.png`,
        url: 'https://pipe.weretrade.com',
        color: '#8b5cf6', // purple
        category: 'tools',
        requiresAuth: true,
    },
    {
        id: 'infrastructure-dog',
        name: 'Infrastructure Dog',
        description: 'Infrastructure monitoring & management',
        icon: `${LOGO_BASE_URL}/infrastructureDog.png`,
        url: 'https://infra.weretrade.com',
        color: '#f97316', // orange
        category: 'tools',
        requiresAuth: true,
    },
    {
        id: 'testing-octopus',
        name: 'Testing Octopus',
        description: 'Test management & automation',
        icon: `${LOGO_BASE_URL}/testingOctopus.png`,
        url: 'https://tests.weretrade.com',
        color: '#06b6d4', // cyan
        category: 'tools',
        requiresAuth: true,
    },
    // External/Public Apps (shown when logged in)
    {
        id: 'weretrade-main',
        name: 'weretradeIT',
        description: 'Main website',
        icon: `${LOGO_BASE_URL}/neuralWhale.png`,
        url: 'https://weretrade.com',
        color: '#6366f1', // indigo
        category: 'external',
        requiresAuth: false,
    },
];
/**
 * Get apps by category
 */
export function getAppsByCategory(category) {
    return APPS_REGISTRY.filter(app => app.category === category);
}
/**
 * Get app by ID
 */
export function getAppById(id) {
    return APPS_REGISTRY.find(app => app.id === id);
}
/**
 * Get apps that require authentication
 */
export function getAuthenticatedApps() {
    return APPS_REGISTRY.filter(app => app.requiresAuth);
}
/**
 * Get apps that don't require authentication (public apps)
 */
export function getPublicApps() {
    return APPS_REGISTRY.filter(app => !app.requiresAuth);
}
